<template>
    <eventi-view-component :jsonData="jsonData" :utente="utente" :pathResource="pathResource" :titoloEvento="titoloEvento" @update="onUpdateJsonData" :linkPrintData="linkPrintData" :isAllegati="true" :isMateriali="false">
        <template slot="tab-content-event">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <b-button size="sm" variant="outline-info outline-primary-noborder sa-margin-right float-sm-right" @click="onClickReferta" class="mb-2">
                        <i class="far fa-edit"></i>
                        Referta
                    </b-button>
                </b-col>
            </b-row>
            <anamnesi-botox-view-component :jsonData="jsonData" @update="onUpdateJsonData"></anamnesi-botox-view-component>
        </template>
    </eventi-view-component>
</template>
<script>
import EventiViewComponent from "../../../base/components/EventiViewComponent.vue";
import EventiMixin from "../../../utility/mixins/EventiMixins";
import UtilityMixin from "../../../../../utility/UtilityMixin";
import AnamnesiBotoxViewComponent from "../components/AnamnesiBotoxViewComponent.vue";
export default {
    props: {
        utente: {
            type: Object,
            default: function () {
                return null;
            },
        },
    },
    mixins: [UtilityMixin],
    components: { EventiViewComponent, AnamnesiBotoxViewComponent },
    computed: {
        idPaziente() {
            return this.$route.query.idPaziente;
        },
        linkPatient() {
            return EventiMixin.getLinkPatient(this.utente, this.idPaziente);
        },
    },
    mounted() {
        this.jsonData.dataEvento = new Date().getTime();
    },
    data() {
        return {
            linkback: null,
            titoloEvento: "Anamnesi Botox",
            pathResource: "/anamnesibotox",
            pathRestValidation: "/validation",
            linkPrintData: null,
            id: "-1",
            isFirmato: false,
            childKey: 0,
            tabIndex: 0,
            showModalLoading: false,
            jsonData: {
                dataEvento: new Date().getTime(),
                fonteDati: "",
                fonteDatiAltro: "",
                allergie: "",
                allergieAltro: "",
                fumo: "",
                malattieAutoimmuni: "",
                malattieAutoimmuniNote: "",
                assunzioneFarmaci: "",
                assunzioneFarmaciNote: "",
                interventiChirurgici: "",
                interventiChirurgiciNote: "",
                precedentiTrattamentiMedicinaEstetica: "",
                precedentiTrattamentiMedicinaEsteticaNote: "",
                motivoVisita: "",
                esameObiettivoLocale: "",
                farmaci: "",
            },
        };
    },
    methods: {
        onFirmaUpdate() {
            let me = this;
            me.loadData();
        },
        onUpdateFile() {
            let me = this;
            me.childKey++;
        },
        onUpdateJsonData(data) {
            let me = this;
            me.jsonData = data;
            if (me.jsonData.firma) {
                me.btnFirmaVisible = false;
            } else {
                me.btnFirmaVisible = true;
            }
            me.linkPrintData = "/pazienteeventi/print/" + me.jsonData.id;
        },
        onClickReferta() {
            this.$router.push("/paziente/botox/visita/edit/-1?idPaziente=" + this.idPaziente);
        },
    },
};
</script>
